import { StyleSheet } from 'aphrodite';

import { TagsDisplay } from '../TagsDisplay';

export class TagsListPartner extends TagsDisplay {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/partners/TagsListPartner.js